<template>

  <section id="plataforma" class="d-flex align-items-center plataforma">

    <div class="container">

      <div class="section-title" data-aos="fade-up">
        <div class="row">
          <h1 data-aos="fade-up">Integrações</h1>
          <h5 class="mb-4" data-aos="fade-up" data-aos-delay="400"> Podemos integrar com qualquer plataforma do mercado ou sistemas de gestão.</h5>
        </div>
      </div>

      <div class="row">

        <div class="col-md-4 col-12 align-items-center mb-4">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
            <img src="../assets/img/logo_greenn.png.webp" class="img-fluid" style="width: 150px; margin-top: 10px;" alt="" data-aos="zoom-in">
          </div>
        </div>

        <div class="col-md-4 col-12 align-items-center mb-4">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
            <img src="../assets/img/logo-hotmart.svg" class="img-fluid" style="width: 180px; margin-top: 7px; margin-bottom: 7px;" alt="" data-aos="zoom-in">
          </div>
        </div>

        <div class="col-md-4 col-12 align-items-center mb-4">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
            <img src="../assets/img/logo-plataforma-sigame-solucoes.png" class="img-fluid" style="width: 135px;" alt="" data-aos="zoom-in">
          </div>
        </div>

        <div class="col-md-4 col-12 align-items-center mb-4">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
            <img src="../assets/img/logo-cranium.svg" class="img-fluid" style="width: 180px; margin-top: 7px; margin-bottom: 7px;" alt="" data-aos="zoom-in">
          </div>
        </div>

      </div>

    </div>
  </section>

</template>

<script>
export default {
  name: 'IntegracaoComp'
}
</script>

<style scoped lang="scss">
.plataforma {
  background-color: $plataforma-bg-color;
  padding: 20px 0px 80px 0px;
  text-align: center;
}

.plataforma .icon-box {
  width: 80%;
  height: 100%;
  padding: 40px;
  position: relative;
  overflow: hidden;
  background: $bg-base;
  box-shadow: $plataforma-icon-box-box-shadow;
  transition: box-shadow 0.3s ease;
  border-radius: 8px;
  z-index: 1;
}

.plataforma .col-md-4 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.plataforma .col-12 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.plataforma img {
  width: 60%;
  filter: grayscale(100);
  transition: all 0.4s ease-in-out;
  display: inline-block;
  padding: 0px 0;
}

.plataforma img:hover {
  filter: none;
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .plataforma img {
    width: 40%;
  }
}

@media (max-width: 575px) {
  .plataforma img {
    width: 30%;
  }
}
</style>
